<template>
  <TempPageVue>
    <template v-slot:left>
      <div class="col-lg-3">
        <UserFeedInfoVue ref="userFeed" props_selectItem="customerPrivateMessage"></UserFeedInfoVue>
      </div>
    </template>
    <template v-slot:content>
      <div id="profile" class="col-lg-9">
        <div class="row">
          <!-- /.col -->
          <div class="col-md-12 pl-md-4">
            <div class="card">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <ul class="nav nav-pills">
                      <li class="nav-item">
                        <a class="nav-link" :class="{ active: true }" href="javascript:void(0);" data-toggle="tab"> {{ $t('Customer.customerPrivateMessage.msg') }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body" v-show="showType === 1">
                <div class="my-profile section-group">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <div class="col-12" v-for="(item, ix) in msgList" :key="ix">
                          <div class="private_talk_fm">
                            <div class="user_icon">
                              <img :src=" MyUser.userId == item.sgL_UsersId?item.toUserLogoBig:item.userLogoBig" />
                              <p class="user_info">
                                <span class="txt">{{
                                 MyUser.userId == item.sgL_UsersId?item.sgL_ToUsersName:item.sgL_UsersName
                                }}</span>
                                <span class="postime">{{
                                  item.sgL_CreateTimeE
                                }}</span>
                              </p>
                            </div>
                            <p class="preview_message">
                              {{ item.sgL_SocketMsg }}
                            </p>
                            <div class="pri_btn_fm">
                              <button class="reply-btn" @click="replay(item)">
                                 {{ $t('Customer.customerPrivateMessage.replay') }}
                              </button>
                              <button class="cross-btn" @click="delMessage(item)"
                               >
                                <i class="fas fa-times-circle c-red btn-fonts2"></i>
                                <p class="c-grey btn-fonts"> {{ $t('Customer.customerPrivateMessage.reject') }}</p>
                              </button>
                              <!-- /* 暂时关闭 v-if="false" */ -->
                              <button class="tick-btn" v-if="false"
                                 @click="agree(item)">
                                <i class="fas fa-check-circle c-green btn-fonts2"></i>
                                <p class="c-grey btn-fonts"> {{ $t('Customer.customerPrivateMessage.agree') }}</p>
                              </button>
                                <!-- <button class="tick-btn" v-if="item.sgL_InvitationStatus !== 'Friends'
                                  // ||item.SGL_IsBlock != true
                                  " @click="agree(item)">
                                  <i class="fas fa-check-circle c-green btn-fonts2"></i>
                                  <p class="c-grey btn-fonts">申請好友</p>
                                </button> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row my-5" style="justify-content: center">
                  <div class="col-12 col-sm-6 col-xs-4">
                    <!--  引用分页组件 -->
                    <pagination v-if="pageParams.total > 0" :currentPage="pageParams.currentPage"
                      :total="pageParams.total" :limit="pageParams.limit" :small="true"
                      @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />
                  </div>
                </div>
                <!-- /.My Profile -->
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.nav-tabs-custom -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
        <div id="replymessage" class="modal fade show" aria-modal="true" data-backdrop="static">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-content-title c-grey">
                  {{ dialog.title }}
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="closeModal">×</span>
                </button>
              </div>
              <div class="modal-body" id="modalBody" style="height: 400px; overflow-y: auto">
                <div v-for="item in dialog.list" :key="item.id" style="margin-bottom: 10px">
                  <div class="feedpost-user friendlist_fm reply-fm">
                    <!-- A user chat txt only Post -->
                    <div class="feedpost card_group" style="margin-bottom: 0px">
                      <div class="group_card-body">
                        <div class="group_feedpost-content">
                          <p class="message_txt">
                            {{ item.sgL_SocketMsg }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="group_feedpost-action" style="height: 40px">
                    <div :class="{
                      'group_feedpost-user':
                        item.sgL_UsersId === loginUser.userId,
                      'group_self_feedpost-user':
                        item.sgL_UsersId !== loginUser.userId,
                    }">
                      <a href="javascript:;">
                        <img class="user-logo mr-2" :src="item.userLogoBig" alt="user-icon" /></a>
                      <span class="group_feedpost-username">
                        <a href="javascript:;">{{ item.sgL_UsersName }} </a>
                      </span>
                      <span class="publish-time" style="display: block">{{
                        item.sgL_CreateTimeE
                      }}</span>
                    </div>
                  </ul>
                </div>
              </div>
              <!-- Input message box -->
              <div class="pri_input_box">
                <div class="fm" style="display: flex;
                        justify-content: space-between;
                        align-items: center;
                      ">
                  <el-input v-model="sendText" :placeholder="$t('Customer.customerPrivateMessage.sendMsg')" style="width: 80%"
                    @keyup.enter.native="sendMsg"></el-input>
                  <el-popover placement="bottom" width="400" trigger="click">
                    <picker set="emojione" @select="addEmoji" :i18n="I18N" />
                    <!-- <div slot="reference" class="emojionearea-button-close"></div> -->

                    <div slot="reference">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                        class="bi bi-emoji-smile" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z" />
                      </svg>
                    </div>
                  </el-popover>
                  <button class="btn-send" style="width: 40px" @click="sendMsg">
                    <i class="far fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
      </div>
    </template>
  </TempPageVue>
</template>
<script>
import pagination from "../common/Page";
import avatarVue from "../common/avatar.vue";
import { Picker } from "emoji-mart-vue";
import UserFeedInfoVue from "@/components/Social/UserFeedInfo.vue";
import TempPageVue from "@/components/Social/TempPage.vue";


export default {
  data() {
    return {
      showType: 1,
      msgList: [],
      sendText: "",
      replayItem: null,
      interId: null,
      pageParams: {
        currentPage: 1,
        limit: 12,
        total: 0,
        pageshow: false,
      },
      dialog: {
        title: "",
        list: [],
      },
      I18N: {
        search: '搜索',
        notfound: 'No Emoji Found',
        categories: {
          search: '搜索結果',
          recent: '經常使用',
          smileys: '表情與情感',
          people: '人物與身體',
          nature: '動物與自然',
          foods: '食物與飲料',
          activity: '活動',
          places: '旅行與地理',
          objects: '物品',
          symbols: '符號標誌',
          flags: '旗幟',
          custom: 'Custom',
        },
      },
      MyUser:JSON.parse(localStorage.getItem('userinfo'))
    };
  },
  components: {
    pagination,
    avatarVue,
    Picker,
    UserFeedInfoVue,
    TempPageVue,
  },
  created() {
    this.getList();
  },
  destroyed() {
    if (this.interId != null) {
      clearInterval(this.interId);
    }
  },
  methods: {
    sendMsg() {
      if (this.sendText) {
        this.$api.commons
          .AddSocketMessage({
            toUsersId: this.isMyself(this.replayItem).Id,
            toUsersName: this.isMyself(this.replayItem).Name,
            content: this.sendText,
          })
          .then((res) => {
            if (res.data.success) {
              this.sendText = "";
              this.getMessageDetail(this.isMyself(this.replayItem).Id).then(() => {
                document.getElementById("modalBody").scrollTop =
                  document.getElementById("modalBody").scrollHeight;
              });
            } else {
              this.$message.error(res.data.error);
            }
          });
      }
    },
    addEmoji(item) {
      // console.log(item);
      this.sendText = this.sendText + item.native;
    },
    closeModal() {
      $("#replymessage").modal("hide");
      if (this.interId != null) {
        clearInterval(this.interId);
      }
    },
    replay(item) {
      this.replayItem = item;
      this.sendText = "";
      this.dialog.title = this.isMyself(item).Name + " " + this.$t('Customer.customerPrivateMessage.dialogue');
      this.dialog.list = [];
      $("#replymessage").modal("show");
      this.getMessageDetail(this.isMyself(item).Id).then((res) => {
        document.getElementById("modalBody").scrollTop =
          document.getElementById("modalBody").scrollHeight;
      });
      if (this.interId != null) {
        clearInterval(this.interId);
      }
      this.interId = setInterval(() => {
        this.getMessageDetail(this.isMyself(item).Id).then();
      }, 3 * 1000);
    },
    getMessageDetail(sgL_ToUsersId) {
      return this.$api.commons
        .GetSocketMessageById({
          ToUsersId: sgL_ToUsersId,
          SkipCount: 0,
          MaxResultCount: 999,
        })
        .then((res) => {
          if (res.data.success) {
            let list = [];
            res.data.result.items.forEach((item) => {
              list.unshift(item);
            });
            this.dialog.list = list;
          } else {
            this.$message.error(res.data.error);
          }
        });
    },
    reject(item) {
      let usersId = this.isYouself(item).Id;
      const req = {
        usersId
      };
      this.$api.social.bolockFalseFriends(req).then((res) => {
        if (res.data.success) {
          this.$message.success(this.$t('message.operatesuccessfully'));
        }
        this.getList();
      });
    },
     delMessage (item) {
      let sgL_ToUsersId = this.isMyself(item).Id;
      const req = {
        sgL_ToUsersId
      };
      this.$api.social.DeleteSockMessage(req).then((res) => {
        if (res.data.success) {
          this.$message.success(this.$t('message.operatesuccessfully'));
        }
        this.getList();
      });
    },
    async agree(item) {
      /**黑名單 改為移除黑名單再添加好友 */
      if ((item.sgL_InvitationStatus == "Blacklist" || item.SGL_IsBlock)) {
        const data = await this.quBolockFalseFriends(item);
        if (data)
          this.getList();
        return;
      }
      const { data } = await this.$api.social.FriendsCreate({ sgL_ToUsersId: this.isMyself(item).Id, });
      if (data.success){
        this.getList();
        this.$message.success(this.$t('message.operatesuccessfully'));
      }
      else
        this.$message.error(data.error.message);
    },

    isMyself(item) {
      if (this.MyUser.userId == item.sgL_UsersId) {
        return {Id:item.sgL_ToUsersId,Name:item.sgL_ToUsersName,logo:item.toUserLogoBig};
      } else {
        return {Id:item.sgL_UsersId,Name:item.sgL_UsersName,logo:item.userLogoBig};
      }
    },
    isYouself (item) {
      if (this.MyUser.userId == item.sgL_UsersId) {
        return { Id: item.sgL_ToUsersId, Name: item.sgL_ToUsersName, logo: item.toUserLogoBig };
      } else {
        return { Id: item.sgL_UsersId, Name: item.sgL_UsersName, logo: item.userLogoBig };
      }
    },

    /**
     * 移除黑名單
     * @param {} item 
     */
    async quBolockFalseFriends(item) {
      const { data: e } = await this.$api.social.blockList({ SGL_UsersId: this.isMyself(item).Id });
      const { data: res } = await this.$api.social.quBolockFalseFriends({ id: e.result.items[0].id, usersId: this.isMyself(item).Id, })
      if (!res.success) {
        this.$message.error({
          type: "error",
          message: res.error.message,
        });
        return false;
      }
      this.$message.success(this.$t('message.operatesuccessfully'));
      return true;
    },

    getList() {
      this.$api.commons
        .GetSocketMessageList({
          SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit, //从第几条开始查，
          MaxResultCount: this.pageParams.limit, //查多少条
        })
        .then((res) => {
          this.msgList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getPicturePublish();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getPicturePublish();
    },
  },
  computed:{
    // isMy_Self(item){
    //   if (this.MyUser.userId == item.sgL_UsersId) {
    //     return {Id:item.sgL_ToUsersId,Name:item.sgL_ToUsersName,logo:item.toUserLogoBig};
    //   } else {
    //     return {Id:item.sgL_UsersId,Name:item.sgL_UsersName,logo:item.userLogoBig};
    //   }
    // }
  }
};
</script>
<style scoped>
.group_self_feedpost-user {
  font-weight: bold;
  font-size: 0.5rem;
  float: left;
  white-space: nowrap;
  width: 140px;
  padding-right: 30px;
  padding-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  background-position: right top;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/group_chat2.png") !important;
}

.group_feedpost-user {
  font-weight: bold;
  font-size: 0.5rem;
  float: right;
  white-space: nowrap;
  width: 155px;
  padding-left: 30px;
  padding-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  background-position: left top;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/group_chat.png");
}

.notclick {
  pointer-events: none;
}

.detailTool {
  position: absolute;
  bottom: 6px;
  padding-right: 6px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-content: center;
}

.album-photo-count-loading {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  bottom: 6px;
  height: 20px;
  display: flex;
  align-content: center;
  justify-content: center;
  margin-right: 5px;
  color: white;
  font-size: 0.75rem;
  padding: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/Customer/customerPrivateMessage.vue